import { Injectable, signal } from '@angular/core';

/**
 * Operazioni in corso che si stanno facendo attendere: mentre ce n'è almeno una compare il loader a tutto schermo e l'inserimento è bloccato
 * (niente clic né tasti), così non si può premere due volte Salva o modificare dati mentre il server lavora. Le operazioni veloci non lo mostrano:
 * si accende solo dopo un ritardo (breve per i salvataggi, più lungo per le semplici letture).
 */
@Injectable({providedIn: 'root'})
export class BusyService
{
    private readonly _slow = signal(0);

    /** Il loader è visibile. */
    readonly visible = this._slow.asReadonly();

    /** Segnala l'inizio di un'operazione; restituisce la funzione da chiamare alla fine (con successo o con errore). */
    start(delayMs: number): () => void
    {
        let counted = false;
        const timer = setTimeout(() =>
        {
            counted = true;
            this._slow.update((n) => n + 1);
        }, delayMs);

        return () =>
        {
            clearTimeout(timer);
            if ( counted )
            {
                counted = false;
                this._slow.update((n) => Math.max(0, n - 1));
            }
        };
    }
}
